import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'app/service/user.service';

// "Legal & Trust": alle Rechtstexte an einer Stelle
@Component({
  standalone: false,
  selector: 'app-legal-overview',
  templateUrl: './legal-overview.component.html',
  styleUrls: ['./legal-document.component.scss']
})
export class LegalOverviewComponent implements OnInit {
  selectedLanguage = 'en';
  supportedLanguages: { code: string; name: string }[] = [
    { code: 'de', name: 'Deutsch' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'pt', name: 'Português' }
  ];

  // Seiten, die die App selbst anzeigt (Teilnehmerinformation steht auf der Einrichtungsseite)
  readonly items = [
    { route: '/terms', title: 'legalPages.terms', text: 'legalPages.termsText' },
    { route: '/privacy', title: 'legalPages.privacy', text: 'legalPages.privacyText' },
    { route: '/participant-info', title: 'legalPages.participantInfo', text: 'legalPages.participantInfoText' },
    { route: '/imprint', title: 'legalPages.imprint', text: 'legalPages.imprintText' }
  ];

  constructor(private translate: TranslateService, private userService: UserService) {
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    const stored = localStorage.getItem('selectedLanguage');
    this.selectedLanguage = this.supportedLanguages.some(l => l.code === stored) ? (stored as string) : 'en';
    this.translate.use(this.selectedLanguage);
  }

  changeLanguage(lang: string) {
    this.selectedLanguage = lang;
    this.translate.use(lang);
    localStorage.setItem('selectedLanguage', lang);
    this.userService.loadLang.next(lang);
  }
}
